// extracted by mini-css-extract-plugin
export var growableInput = "_6k-0";
export var tagContainer = "_6k-2";
export var textInput = "_6k-1";